<script>
import Dialog from '@/components/v3/base/Dialog';
import Typography from '@/components/v3/base/Typography';
import Button from '@/components/v3/base/Button';

export default {
  components: {
    Dialog,
    Typography,
    Button,
  },

  props: {
    src: {
      Type: String,
      default:
        'https://www.loom.com/embed/258698558d8e47c79e506aa9ea20585a?sid=832430e3-6113-4982-a77c-380fabbe2a40',
    },

    hideButton: {
      type: Boolean,
      default: false,
    },

    isFastTrack: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      videoPopup: false,
      popupWidth: 1096,
    };
  },

  methods: {
    onOpen() {
      this.videoPopup = true;
    },
  },
};
</script>
<!-- eslint-disable vue/no-undef-components -->
<template>
  <Dialog
    v-model="videoPopup"
    :width="popupWidth"
    close
    @close="videoPopup = false"
  >
    <div class="tw-p-6">
      <div>
        <div
          style="
            position: relative;
            padding-bottom: 57.75401069518716%;
            height: 0;
          "
        >
          <iframe
            :src="src"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
          ></iframe>
        </div>
        <div
          v-if="!hideButton"
          class="tw-mt-12 tw-grid md:tw-flex tw-items-center tw-justify-between tw-gap-6"
        >
          <Typography variant="headline-5">
            Ready to explore further with a live demo?
          </Typography>
          <div>
            <a href="/contact">
              <Button
                size="xl"
                class="tw-min-w-[360px] tw-w-full tw-text-center"
              >
                Book a demo
              </Button>
            </a>
          </div>
        </div>
        <div v-else class="tw-text-center">
          <div v-if="isFastTrack">
            <Typography
              variant="headline-5"
              class="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-pt-3"
            >
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.825 22L7.45 14.975L2 10.25L9.2 9.625L12 3L14.8 9.625L22 10.25L16.55 14.975L18.175 22L12 18.275L5.825 22Z"
                    fill="#212121"
                  />
                </svg>
              </div>
              Hirefly FastTrack
            </Typography>
            <Typography variant="body-1" class="tw-mt-2">
              Automate your candidate screening with AI, cutting inbound review
              time by 80%.
            </Typography>
          </div>
          <div v-else>
            <Typography
              variant="headline-5"
              class="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-pt-3"
            >
              <div>
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.449805 8.57504L4.6498 4.37504C4.88314 4.1417 5.15814 3.97504 5.4748 3.87504C5.79147 3.77504 6.11647 3.75837 6.4498 3.82504L8.3748 4.17504C7.45814 5.20837 6.71647 6.18754 6.1498 7.11254C5.58314 8.03754 5.05814 9.1167 4.5748 10.35L0.449805 8.57504ZM5.4998 10.8C5.9498 9.58337 6.51647 8.43754 7.1998 7.36254C7.88314 6.28754 8.65814 5.3167 9.52481 4.45004C10.9915 2.98337 12.6665 1.88754 14.5498 1.16254C16.4331 0.437537 18.1915 0.216703 19.8248 0.500037C20.1081 2.13337 19.8915 3.8917 19.1748 5.77504C18.4581 7.65837 17.3665 9.33337 15.8998 10.8C15.0331 11.6667 14.0581 12.4417 12.9748 13.125C11.8915 13.8084 10.7415 14.375 9.52481 14.825L5.4998 10.8ZM12.6498 7.67504C12.9831 8.00837 13.3956 8.17504 13.8873 8.17504C14.379 8.17504 14.7915 8.00837 15.1248 7.67504C15.4581 7.3417 15.6248 6.9292 15.6248 6.43754C15.6248 5.94587 15.4581 5.53337 15.1248 5.20004C14.7915 4.8667 14.379 4.70004 13.8873 4.70004C13.3956 4.70004 12.9831 4.8667 12.6498 5.20004C12.3165 5.53337 12.1498 5.94587 12.1498 6.43754C12.1498 6.9292 12.3165 7.3417 12.6498 7.67504ZM11.7748 19.875L9.9748 15.75C11.2081 15.2667 12.2873 14.7417 13.2123 14.175C14.1373 13.6084 15.1165 12.8667 16.1498 11.95L16.4998 13.875C16.5665 14.2084 16.5498 14.5375 16.4498 14.8625C16.3498 15.1875 16.1831 15.4667 15.9498 15.7L11.7748 19.875ZM2.0498 14.05C2.63314 13.4667 3.34147 13.1709 4.1748 13.1625C5.00814 13.1542 5.71647 13.4417 6.2998 14.025C6.88314 14.6084 7.1748 15.3167 7.1748 16.15C7.1748 16.9834 6.88314 17.6917 6.2998 18.275C5.86647 18.7084 5.19147 19.0667 4.2748 19.35C3.35814 19.6334 1.99147 19.9 0.174805 20.15C0.424805 18.3334 0.691471 16.9709 0.974805 16.0625C1.25814 15.1542 1.61647 14.4834 2.0498 14.05Z"
                    fill="#212121"
                  />
                </svg>
              </div>
              Hirefly Autopilot
            </Typography>
            <Typography variant="body-1" class="tw-mt-2">
              Automate sourcing, delivering interview-ready candidates directly
              to your inbox.
            </Typography>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>
